import { h, Fragment } from "preact";
import { useState, useEffect, useContext } from "preact/hooks";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Box,
	Button,
	Chip,
	FormControlLabel,
	Grid,
	Paper,
	Stack,
	Switch,

	Tooltip,
	Typography,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArchiveIcon from '@mui/icons-material/Archive';
import DownloadFile from "../Common/DownloadFile";
import { AppContext } from "../../AppContext";

import EmailIcon from "@mui/icons-material/Email";


export default function Dataroom({ values, id, archive }) {

	const [state, setState] = useState(values);
	const app = useContext(AppContext);

	const [expanded, setExpanded] = useState(false);

	const handleChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};
	const dataRoomUpdate = () => {
		console.log("dataRoomUpdate");
		const requestOptions = {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		};
		fetch("/api/dba6598cea0f46da937759765d7358d2/" + id, requestOptions)
			.then((response) => {
				return response.json();
			})
			.then((res) => {
				switch (res.res) {
					case "ok":
						setState((state) => ({
							...state,
							...res.pld.dr,
						}));

						break;
					case "err":
						break;
					default:
						break;
				}
			});
	};


	const [uncompleteOnly, setUncompleteOnly] = useState(false);
	const [mandatoryOnly, setMandatoryOnly] = useState(false);
	var o = new Date();
	if (state === undefined) return;
	//console.log("uid", state.archive_uid)
	return (
		<div style="padding: 0px; ">
			<Stack spacing={1}>
				<Paper style="padding: 10px;">
					<Stack direction={"row"} spacing={1} alignItems={"center"} justifyContent={"space-between"}>
						<Stack>
							<Typography variant="h5" style="margin-right: 10px;">Catégories</Typography>
							<Typography variant="body1" style="margin-right: 10px;">N'afficher que les catégories</Typography>
							<FormControlLabel checked={uncompleteOnly}
								onChange={() => { setUncompleteOnly(!uncompleteOnly) }} control={<Switch />} label="Incomplètes" />
							<FormControlLabel checked={mandatoryOnly}
								onChange={() => { setMandatoryOnly(!mandatoryOnly) }} control={<Switch />} label="Obligatoires" />
						</Stack>

						{!archive && <Button
							endIcon={<ArchiveIcon />}
							variant="contained"
							onClick={() => {
								app.refPopUp.current.handleChangeState(
									{
										opened: true,
										type: "032",
										params: {
											uid: id
										}
									})
							}}		>
							Télécharger tous les documents
						</Button>}
						{archive && <div>
							<Typography variant="h5">Archive prête</Typography>
							<DownloadFile f={{ name: `archive-${o.toISOString().replace(" ", "_")}.zip`, u: archive }} mode="arch" />
						</div>}
					</Stack>
				</Paper>
				<div>
					{state.deal && (
						<Accordion expanded={expanded === "panel1"} onChange={handleChange("panel1")}>
							<AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
								<Typography variant="h5">Documents officiels</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<Grid container spacing={1}>
									{state.deal.de.filter((de) => { return (mandatoryOnly ? (!de.inm) : true) && (uncompleteOnly ? (!de.ic) : true) }).map((doc) => {
										return <Grid item sm={3} xs={6}>
											<FileSlot doc={doc} cl={values.cl} handleOpenNotaryProbingDialog={() => {
												app.refPopUp.current.handleChangeState(
													{
														opened: true,
														type: "016",
														params: {
															docs: doc,
															title: values.cl[doc.c].nm,
															dataRoomUpdate: dataRoomUpdate

														}
													})
											}} />
										</Grid>;
									})}
								</Grid>
							</AccordionDetails>
						</Accordion>
					)}
					{state && state.re && (
						<Accordion expanded={expanded === "panel4"} onChange={handleChange("panel4")}>
							<AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel4bh-content" id="panel4bh-header" >
								<Grid container>
									<Grid item xs={8}>
										<Typography variant="h5">Biens</Typography>
									</Grid>
									<Grid item xs>

									</Grid>
								</Grid>
							</AccordionSummary>
							<AccordionDetails>
								{state &&
									state.re &&
									state.re.re &&
									state.re.re.map((re) => {
										console.log("re", re)
										return (
											<Stack spacing={1}>
												<Typography variant="h5" style="margin-left: 8px; margin-top: 8px;">
													{re.hd}
												</Typography>
												<Grid container spacing={1}>
													{re.de && re.de.filter((de) => { return (mandatoryOnly ? (!de.inm) : true) && (uncompleteOnly ? (!de.ic) : true) }).map((doc) => {
														const handleOpenNotaryProbingDialog = () => {
															app.refPopUp.current.handleChangeState(
																{
																	opened: true,
																	type: "016",
																	params: {
																		docs: doc,
																		title: values.cl[doc.c].nm,
																		dataRoomUpdate: dataRoomUpdate

																	}
																})
														}
														if (state.currentCat !== undefined && state.currentCat === doc.u) { handleOpenNotaryProbingDialog() }
														return (
															<Grid item sm={3} xs={6}>
																<FileSlot
																	doc={doc}
																	cl={values.cl}
																	handleOpenNotaryProbingDialog={() => {
																		setState({ ...state, currentCat: doc.u })
																		handleOpenNotaryProbingDialog()
																	}}

																/>
															</Grid>
														);
													})}
												</Grid>
											</Stack>
										);
									})}
							</AccordionDetails>
						</Accordion>
					)}
					{state && state.vn && (
						<Accordion expanded={expanded === "panel2"} onChange={handleChange("panel2")}>
							<AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2bh-content" id="panel2bh-header">
								<Grid container>
									<Grid item xs={8}>
										<Typography variant="h5">Vendeurs</Typography>
									</Grid>
									<Grid item xs>
										{/* {state.vn.vn.length > 0 && <LinearProgressWithLabel value={state.vn.stats.ic * 100 / state.vn.stats.im} />} */}
									</Grid>
								</Grid>
							</AccordionSummary>
							<AccordionDetails>
								<Stack spacing={1}>
									{state.vn && state.vn.vn && state.vn.vn.map((vn) => {
										return (
											<Fragment>
												<Stack spacing={1} direction="row" justifyContent="flex-start" alignItems={"center"}>
													<Typography variant="h5">{vn.hd}</Typography>
													<Tooltip title={"Envoyer un message"} placement="right" arrow>
														<EmailIcon onClick={() =>
															app.refPopUp.current.handleChangeState(
																{
																	opened: true,
																	type: "020",
																	params: {
																		hd: vn.hd,
																		u: vn.u
																	}
																})
														} color="primary" />
													</Tooltip>
												</Stack>
												<Grid container spacing={1}>
													{vn.de && vn.de.filter((de) => { return (mandatoryOnly ? (!de.inm) : true) && (uncompleteOnly ? (!de.ic) : true) }).map((doc) => {

														const handleOpenNotaryProbingDialog = () => {
															app.refPopUp.current.handleChangeState(
																{
																	opened: true,
																	type: "016",
																	params: {
																		docs: doc,
																		title: values.cl[doc.c].nm,
																		dataRoomUpdate: dataRoomUpdate

																	}
																})
														}
														return (
															<Grid item sm={3} xs={6}>
																<FileSlot
																	doc={doc}
																	cl={values.cl}
																	handleOpenNotaryProbingDialog={() => {
																		setState({ ...state, currentCat: doc.u })
																		handleOpenNotaryProbingDialog()
																	}}
																/>
															</Grid>
														);
													})}
												</Grid>
											</Fragment>
										);
									})}
								</Stack>
							</AccordionDetails>
						</Accordion>
					)}
					{state && state.aq && (
						<Accordion expanded={expanded === "panel3"} onChange={handleChange("panel3")}>
							<AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3bh-content" id="panel3bh-header">
								<Grid container>
									<Grid item xs={8}>
										<Typography variant="h5">Acquéreurs</Typography>
									</Grid>
									<Grid item xs>
										{/* {state.aq.aq.length > 0 && <LinearProgressWithLabel value={state.aq.stats.ic * 100 / state.aq.stats.im} />} */}
									</Grid>
								</Grid>
							</AccordionSummary>
							<AccordionDetails>
								{state &&
									state.aq && state.aq.aq &&
									state.aq.aq.map((aq) => {
										return (
											<Fragment>
												<Stack spacing={1} direction="row" justifyContent="flex-start" alignItems={"center"}>
													<Typography variant="h5">{aq.hd}</Typography>
													<Tooltip title={"Envoyer un message"} placement="right" arrow>
														<EmailIcon onClick={() => app.refPopUp.current.handleChangeState(
															{
																opened: true,
																type: "020",
																params: {
																	hd: aq.hd,
																	u: aq.u,
																}
															})} color="primary" />
													</Tooltip>
												</Stack>
												<Grid container spacing={1}>
													{aq.de && aq.de.filter((de) => { return (mandatoryOnly ? (!de.inm) : true) && (uncompleteOnly ? (!de.ic) : true) }).map((doc) => {

														return (
															<Grid item sm={3} xs={6}>
																<FileSlot
																	doc={doc}
																	cl={values.cl}
																	handleOpenNotaryProbingDialog={() => {
																		setState({ ...state, currentCat: doc.u })
																		handleOpenNotaryProbingDialog()
																	}}
																/>
															</Grid>
														);
													})}
												</Grid>
											</Fragment>
										);
									})}
								{values && values.aq && values.aq.length === 0 && (
									<Typography variant="body1">
										<em>Aucun acquéreur</em>
									</Typography>
								)}
							</AccordionDetails>
						</Accordion>
					)}
				</div>
			</Stack>
		</div>
	);
}

function FileSlot({ doc, cl, handleOpenNotaryProbingDialog }) {
	//	console.log("FileSlot", doc);
	return (
		<Paper
			style="padding: 5px; background-color: rgba(244, 246, 248, 0.81); cursor: pointer; height: 100%"
			onClick={() => handleOpenNotaryProbingDialog()}
		>
			<Stack spacing={1} alignItems="center" justifyContent="space-between" style="height: 100%">

				<Typography variant="h5" style="text-align: center;">
					{cl[doc.c].nm}
				</Typography>
				<Box display={"flex"} justifyContent={"center"} alignItems="flex-end" >
					<Box >
						<Stack spacing={1} alignItems={"center"} justifyContent={"center"} >
							<Chip
								size="small"
								color={doc.inm ? "info" : "primary"}
								label={doc.inm ? "Facultatif" : "Obligatoire"}
							/>
							<Typography variant="body2" >
								<Chip
									size="small"
									color={doc.r.length > 0 ? "success" : doc.inm ? "default" : "error"}
									label={doc.r.length > 0 ? `${doc.r.length} document${doc.r.length > 1 ? "s" : ""}` : <em>Pas&nbsp;de&nbsp;document</em>}
								/>

							</Typography>


						</Stack>
					</Box>
				</Box>
			</Stack>
		</Paper>
	);
}
